import HasToBeBackofficeGuard from 'app/core/guards/HasToBeBackofficeGuard';
import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

import { HasToBeLoggedInGuard } from '../../../guards/HasToBeLoggedInGuard';

const Projects = lazy(
  () => import('../../../../main/elevators/admin/projects/Projects')
);

const ProjectDetails = lazy(
  () =>
    import(
      '../../../../main/elevators/admin/projects/project-details/ProjectDetails'
    )
);

// View exactly like agency view without edit options
const EquipmentDetails = lazy(
  () =>
    import(
      '../../../../main/elevators/agency/equipment-details/EquipmentDetails'
    )
);

// View exactly like user view TODO: provide user view when ready
const PaymentRequestView = lazy(
  () =>
    import(
      '../../../../main/elevators/agency/payment-request/PaymentRequestView'
    )
);

// View exactly like user view
const Certificates = lazy(
  () => import('../../../../main/elevators/certificates/Certificates')
);

const ReportDetails = lazy(
  () => import('../../../../main/elevators/admin/report-details/ReportDetails')
);

const Inspections = lazy(
  () => import('../../../../main/elevators/admin/inspections/Inspections')
);

const PREFIX = '/admin/elevators/';

export const adminElevatorsRoutes: Array<RouteConfig> = [
  {
    path: PREFIX + 'projects/:id',
    exact: true,
    component: () => <ProjectDetails />,
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'equipment/:equipmentId',
    exact: true,
    component: () => <EquipmentDetails />,
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'projects',
    exact: true,
    component: () => <Projects />,
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'certificates',
    exact: true,
    component: () => <Certificates />,
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'Inspections',
    exact: true,
    component: () => <Inspections />,
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'report/:id',
    exact: true,
    component: () => <ReportDetails />,
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'projects/:id/payment-request/:paymentRequestId',
    exact: true,
    component: () => <PaymentRequestView />,
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
];
